/**
 * A BASE OFICIAL DE INSTITUIÇÕES, COM TIPOS — T18.9.
 *
 * A busca vem do repositório mvpconsultorialtda/instituicoes-ensino, instalada aqui por
 * `node ferramentas/instalar.mjs hqlab` (não edite a cópia: edite lá e reinstale). Ela é JS puro;
 * este arquivo só dá tipo a ela, para o resto do HQ-Lab não depender de `any`.
 *
 * O JSON (16.243 instituições da Bahia, INEP) fica em public/ e só é baixado quando a tela pede.
 */
// @ts-ignore — módulo .mjs sem declaração de tipos; os tipos estão logo abaixo.
import { carregarBase as carregarBaseJs, criarBase as criarBaseJs } from "./instituicoes-ensino.mjs";
import type { InstituicaoDaBase } from "./api";

export interface FiltrosDaBusca {
  nivel?: "basica" | "superior";
  rede?: string;
  municipio?: string;
  limite?: number;
}

export interface BaseDeEscolas {
  fonte: Record<string, string>;
  geradoEm: string;
  buscar(texto?: string, filtros?: FiltrosDaBusca): InstituicaoDaBase[];
  porId(id: string): InstituicaoDaBase | null;
  municipios(filtro?: { nivel?: string }): string[];
}

export function carregarBase(url = `${process.env.PUBLIC_URL || ""}/instituicoes-ba.json`): Promise<BaseDeEscolas> {
  return carregarBaseJs(url) as unknown as Promise<BaseDeEscolas>;
}

/** Para teste: monta a base a partir do documento já lido. */
export function criarBase(doc: unknown): BaseDeEscolas {
  return criarBaseJs(doc) as unknown as BaseDeEscolas;
}

/** Como a rede aparece para quem lê. */
export const ROTULO_REDE: Record<string, string> = {
  federal: "federal",
  estadual: "estadual",
  municipal: "municipal",
  privada: "privada",
};
